import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { LkpBanksModel } from 'src/app/models/LkpBanksModel';
import { LkpBanksService } from 'src/app/services/LkpBanksService';
import { formatDate } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { CodessearchComponent } from '../codessearch/codessearch.component';
import { SuppliesModel } from 'src/app/models/SuppliesModel';
import { SuppliesService } from 'src/app/services/SuppliesService';
import swal from 'sweetalert2';
import { LkpExpenssesModel } from 'src/app/models/LkpExpenssesModel';
import { LkpExpenssesService } from 'src/app/services/LkpExpenssesService';
import { DataBankService } from 'src/app/services/DataBankService';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { LkpRevenueModel } from 'src/app/models/LkpRevenueModel';
import { LkpRevenueService } from 'src/app/services/LkpRevenueService';
import { HospitalsModel } from 'src/app/models/HospitalsModel';
import { HospitalsService } from 'src/app/services/HospitalsService';
import { DoctorssearchComponent } from '../doctorssearch/doctorssearch.component';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { LkpStoresService } from 'src/app/services/LkpStoresService';
import { ClassificationCModel } from 'src/app/models/ClassificationCModel';
import { ClassificationService } from 'src/app/services/ClassificationService';
import { ClassificationModel } from 'src/app/models/ClassificationModel';
import { ItemsService } from 'src/app/services/ItemsService';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { ItemssearchComponent } from '../itemssearch/itemssearch.component';
import { URLsConfig } from 'src/app/URLsConfig';
import { CustomersSearchComponent } from '../customers-search/customers-search.component';
import { CustomersService } from 'src/app/services/customers.service';
import { CustomersModel } from 'src/app/models/customers-model';



@Component({
  selector: 'app-acc-rep-filter',
  templateUrl: './acc-rep-filter.component.html',
  styleUrls: ['./acc-rep-filter.component.css']
})
export class AccRepFilterComponent implements OnInit {

  wk_Title = '';
  trbank = '9';
  trcln_supp ='';
  trcln_supp_Name ='';
  trclass = '';
  trhospital = '';
  trdoctor ='';
  trdoctor_Name ='';
  itClass = 'S04';
  hedstore = '1'
  detitem = '';
  detitemname = '';
  PriceType = '3';
  wk_Patient_Customer = 'مريض';
  bankList: LkpBanksModel[] =[];
  hospitalList: HospitalsModel[] =[];
  classificationList : ClassificationModel[]=[];

  FromDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  ToDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  HiedBank = false;
  HiedDate = false;
  HidSupplier = false;
  HidOption = false;
  HidExpenses = false;
  HiedPatirnt = false
  HidRevenue = false;
  HidHospital = false;
  HidDoctor = false;
  HidClass = false;
  HidStore = false;
  HidItem = false;
  HidPrice = false;

  Wk_Option ='D';
  Wk_Worrning_Message ='';

  expenssesList : LkpExpenssesModel[] = [];
  revenueList : LkpRevenueModel[] = [];
  storesList: LkpStoresModel[] = [];

  constructor(public lkpbanksService : LkpBanksService,
    public suppSelectedData : SuppliesModel,
    public suppliesService : SuppliesService,
    public lkpexpenssesService : LkpExpenssesService,
    public dataBankService : DataBankService,
    public patientsSelectedData : DatabankModel,
    public lkprevenueService : LkpRevenueService,
    public hospitalService : HospitalsService,
    public storesservice : LkpStoresService,
    public classificationService : ClassificationService,
    public doctorSelectedData : DoctorsModel,
    public doctorsService : DoctorsService,
    public itemsservice : ItemsService,
    public customerservice : CustomersService,
    public items :ItemsModel,
    public storage: LocalStorageService,
    public route: Router,
    public translate: TranslateService,
    private dialogref: MatDialog,
    public urlsConfig :URLsConfig,
    ) { }

  ngOnInit(): void {
    this.LookupBanks();
    this.LookupExpensses();
    this.LookupRevenueType();
    this.lookupHospital();
    this.retriveStoresLookupTop();
    this.retriveClassificationLookupTop();

    this.HiedBank =     this.storage.retrieve('stgHidBank'),
    this.HiedDate =     this.storage.retrieve('stgHidDate')
    this.HidSupplier=   this.storage.retrieve('stgHidSupplier')
    this.HidOption=     this.storage.retrieve('stgHidoption')
    this.HidExpenses=   this.storage.retrieve('stgHidExpenses')
    this.wk_Title =     this.storage.retrieve('stgTitle')
    this.HiedPatirnt =  this.storage.retrieve('stgHidPatient')
    this.HidRevenue  =  this.storage.retrieve('stgHidRev')
    this.HidHospital  = this.storage.retrieve('stgHidHospital')
    this.HidDoctor  = this.storage.retrieve('stgHidDoctor')
    this.HidClass  =  this.storage.retrieve('stgHidClass')
    this.HidStore  = this.storage.retrieve('stgHidStore')
    this.HidItem  = this.storage.retrieve('stgHidItem')
    this.HidPrice  =  this.storage.retrieve('stgHidPrice')
    if( this.storage.retrieve('stgcompCode') =='10'){
      this.wk_Patient_Customer = 'عميل';
    }

    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  openDialogDoctor(){
    const dialogRef = this.dialogref.open(DoctorssearchComponent,
      {
        data: {
          dataKey: this.doctorSelectedData,
          type : '',
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.trdoctor = result.docCode;
        this.trdoctor_Name = result.docName;

        this.retrivedoctors();
        dialogSubmitSubscription.unsubscribe();
      });
  }
  retrivedoctors(){
    this.doctorsService.getdoctors(this.trdoctor,this.storage.retrieve('stgcompCode')).subscribe((data: DoctorsModel) => {

      this.trdoctor_Name = data.docName;


    }
    );
  }
  RetriveItems(){
    this.itemsservice.getitems(this.detitem, this.storage.retrieve('stgcompcode')).subscribe((data: ItemsModel) => {
      this.detitemname = data.itTName;


    }
    )
  }
  LookupRevenueType(){
    this.lkprevenueService
    .getRevenueLookupTop(this.storage.retrieve('stgcompCode'))
    .subscribe((data: LkpRevenueModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.revenueList[i] = data[i];
      }
    });
  }
  retriveStoresLookupTop() {
    this.storesList = [];
    this.storesservice.LkpStoresLookupTop(this.storage.retrieve('stgcompCode')).subscribe((data: LkpStoresModel[]) => {
      for (let i = 0; i < data.length; i++) {
         this.storesList[i] = data[i];
         this.hedstore = data[i].strcode;

      }

    })
  }
  retriveClassificationLookupTop() {
    this.classificationService
      .getClassificationLookupTop(this.storage.retrieve('stgcompCode'))
      .subscribe((data: ClassificationModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.classificationList[i] = data[i];
        }
      });
  }
  openDialogItem(){
    const dialogRef = this.dialogref.open(ItemssearchComponent,
      {
        data: {
          dataKey: this.items,

        }
      });

    dialogRef.afterClosed().subscribe(result => {
    });
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.detitem = result.itCode;
        this.detitemname = result.itTName;

        dialogSubmitSubscription.unsubscribe();
      });
  }
  lookupHospital(){
    this.hospitalService
    .getHospitalsLookupTop(this.storage.retrieve('stgcompCode'))
    .subscribe((data: HospitalsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.hospitalList[i] = data[i];
      }

    });
  }
  openDialogPatient(){
       if( this.storage.retrieve('stgcompCode') !='10'){
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
      data: {
        dataKey: this.patientsSelectedData,
      },
      width: '55vw',
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.trcln_supp = result.patientCode;
        this.RetrivePatient();

        dialogSubmitSubscription.unsubscribe();

      });
    }
  if( this.storage.retrieve('stgcompCode') =='10'){
    const dialogRef = this.dialogref.open(CustomersSearchComponent, {
      data: {
        dataKey: this.patientsSelectedData,
      },
      width: '55vw',
    });
    dialogRef.afterClosed().subscribe((result) => {});
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.trcln_supp = result.patientCode;
        this.RetriveCustomer();

        dialogSubmitSubscription.unsubscribe();

      });
        }
  }

  RetrivePatient(){
    if (this.storage.retrieve('stgCompCode') == '10')
      {this.customerservice.getPatient(this.trcln_supp,this.storage.retrieve('stgcompCode')).subscribe((data: CustomersModel) => {
      this.trcln_supp_Name = data.patientFName;
    })}
    else
       {
    this.dataBankService.getPatient(this.trcln_supp,this.storage.retrieve('stgcompCode')).subscribe((data: DatabankModel) => {
      this.trcln_supp_Name = data.patientFName;
    })}
  }
   RetriveCustomer(){
    this.customerservice.getPatient(this.trcln_supp,this.storage.retrieve('stgcompCode')).subscribe((data: CustomersModel) => {
      this.trcln_supp_Name = data.patientFName;
    })
  }
  LookupExpensses(){
    this.lkpexpenssesService
    .getExpenssesLookupTop(this.storage.retrieve('stgcompCode'))
    .subscribe((data: LkpExpenssesModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.expenssesList[i] = data[i];
      }

    });
  }
  switchArabic(){
    this.translate.use('ar');
    document.documentElement.dir = "rtl";
  }
  switchEnglish(){
    this.translate.use('en');
    document.documentElement.dir = "ltr";
  }
  openDialogSupplier(){
    const dialogRef = this.dialogref.open(CodessearchComponent,
      {
        data: {
          dataKey: this.suppSelectedData
        }
    });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
       dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.trcln_supp = result.supCode;
        this.trcln_supp_Name = result.supName;

        this.retrivesupplier();
        dialogSubmitSubscription.unsubscribe();

      });
  }
  retrivesupplier(){
    this.suppliesService.getsupplies(this.trcln_supp,this.storage.retrieve('stgcompCode')).subscribe((data: SuppliesModel) => {
      this.trcln_supp_Name = data.supName;

    })
  }
  Print(){
    console.log("-this.wk_Title-",this.wk_Title,this.PriceType);


    if( this.wk_Title == 'Expenses from Date To Date')
    {
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgBank', this.trbank);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/ExpenssesReport1']);
    }


    if( this.wk_Title == 'Visits Share from Date to Date')
    {
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgBank', this.trbank);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));

       const compcode = this.storage.retrieve('stgcompCode').trim();
       const repPathEng1 = this.urlsConfig.WebRepor_ServertURL_Focu + 'VisitsFees' + '&rs:Command=Render&FromDate=' +  this.FromDate+'&ToDate='+ this.ToDate;

      window.open(repPathEng1, '_blank', 'scrollbars=yes,resizable=yes,toolbar=yes,menubar=yes');

      }

  if( this.wk_Title == 'Suppervision Share from Date to Date')
    {
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgBank', this.trbank);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));

       const compcode = this.storage.retrieve('stgcompCode').trim();
       const repPathEng1 = this.urlsConfig.WebRepor_ServertURL_Focu + 'SupportFees' + '&rs:Command=Render&FromDate=' +  this.FromDate+'&ToDate='+ this.ToDate;

      window.open(repPathEng1, '_blank', 'scrollbars=yes,resizable=yes,toolbar=yes,menubar=yes');

      }

    if( this.wk_Title == 'Expenses by Supplier' && this.Wk_Option =='D')
    {
        if( this.trcln_supp ==''){
          this.Wk_Worrning_Message ='تأكد من كود المورد'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgSupplier', this.trcln_supp);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/ExpenssesSupplier']);
    }
    if( this.wk_Title == 'Expenses by Supplier' && this.Wk_Option =='T')
    {
        if( this.trcln_supp !=''){
          this.Wk_Worrning_Message ='يجب حذف كود المورد'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgSupplier', this.trcln_supp);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/ExpenssesSupplierT']);
    }

    if( this.wk_Title == 'Expenses by Type' && this.Wk_Option =='D')
    {
        if( this.trclass ==''){
          this.Wk_Worrning_Message ='تأكد من كود المصروف'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgClass', this.trclass);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/ExpenssesClass']);
    }

    if( this.wk_Title == 'Expenses by Type' && this.Wk_Option =='T')
    {
        if( this.trclass !=''){
          this.Wk_Worrning_Message ='يجب حذف كود المصروف'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgClass', this.trclass);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/ExpenssesClassT']);
    }
    //////////==================== Revenue ==================
    if( this.wk_Title == 'Revenue from Date To Date')
    {
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgBank', this.trbank);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/RevenueReport1']);
    }
    if( this.wk_Title == 'Revenue by Patient' && this.Wk_Option =='D')
    {
        if( this.trcln_supp ==''){
          this.Wk_Worrning_Message ='تأكد من كود المريض'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgPatient', this.trcln_supp);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/RevenuePatient']);
    }
    if( this.wk_Title == 'Revenue by Patient' && this.Wk_Option =='T')
    {
        if( this.trcln_supp !=''){
          this.Wk_Worrning_Message ='يجب حذف كود المريض'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgClass', this.trclass);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/RevenuePatientT']);
    }
    if( this.wk_Title == 'Revenue by Type' && this.Wk_Option =='D')
    {
        if( this.trclass ==''){
          this.Wk_Worrning_Message ='تأكد من كود نوع الأيراد'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgClass', this.trclass);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/RevenueClass']);
    }
    if( this.wk_Title == 'Revenue by Type' && this.Wk_Option =='T')
    {
        if( this.trclass !=''){
          this.Wk_Worrning_Message ='يجب حذف كود نوع الإيراد'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgClass', this.trclass);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/RevenueClassT']);
    }
    if( this.wk_Title == 'Revenue By Branch' && this.Wk_Option =='D')
    {
        if( this.trhospital ==''){
          this.Wk_Worrning_Message ='تأكد من كود الفرع/المستشفى'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgHospital', this.trhospital);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/RevenueHospital']);
    }
    if( this.wk_Title == 'Revenue By Branch' && this.Wk_Option =='T')
    {
        if( this.trhospital !=''){
          this.Wk_Worrning_Message ='تأكد من حذف كود الفرع/المستشفى'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgHospital', this.trhospital);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/RevenueHospitalT']);
    }
    if( this.wk_Title == 'Revenue By Doctor' && this.Wk_Option =='D')
    {
        if( this.trdoctor ==''){
          this.Wk_Worrning_Message ='تأكد من كود الطبيب'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgDoctor', this.trdoctor);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/RevenueDoctor']);
    }

    if( this.wk_Title == 'Revenue By Doctor' && this.Wk_Option =='T')
    {
        if( this.trdoctor !=''){
          this.Wk_Worrning_Message ='تأكد من حذف كود الطبيب'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgDoctor', this.trdoctor);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/RevenueDoctorT']);
    }

    if( this.wk_Title == 'Cash/Bank Transactions' && this.Wk_Option =='D')
    {
        if( this.trbank ==''){
          this.Wk_Worrning_Message ='تأكد من كود الخزينة'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgBank', this.trbank);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/Safe_Bank_Transactions']);
    }

    if( this.wk_Title == 'Cash/Bank Transactions' && this.Wk_Option =='T')
    {
        if( this.trbank ==''){
          this.Wk_Worrning_Message ='تأكد من كود الخزينة'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgBank', this.trbank);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/Safe_Bank_TransactionsT']);
    }

    if( this.wk_Title == 'Patient Acc. statement' && this.Wk_Option =='D')
    {
        if( this.trcln_supp ==''){
          this.Wk_Worrning_Message ='تأكد من كود المريض'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgPatient', this.trcln_supp);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/PatientAcc']);
    }
    if( this.wk_Title == 'Patient Acc. statement' && this.Wk_Option =='T')
    {
        if( this.trcln_supp !=''){
          this.Wk_Worrning_Message ='تأكد من حذف كود المريض'
          this.MessageWarrning();
          return;
        }
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);
        this.storage.store('stgPatient', this.trcln_supp);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/PatientAccT']);
    }

    if( this.wk_Title == 'Invoices from Date to Date')
    {
        this.storage.store('stgFromDate', this.FromDate);
        this.storage.store('stgToDate', this.ToDate);

        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/Sales']);
    }
    if( this.wk_Title == 'Discounts from date to date')
      {
          this.storage.store('stgFromDate', this.FromDate);
          this.storage.store('stgToDate', this.ToDate);

          this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
          this.route.navigate(['report-vewier', 'CocReports/SalesDiscounts']);
      }
    if( this.wk_Title == 'Sales By Item')
        {
            this.storage.store('stgFromDate', this.FromDate);
            this.storage.store('stgToDate', this.ToDate);

            this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
            this.route.navigate(['report-vewier', 'CocReports/SalesItems']);
      }
    if( this.wk_Title == 'Item Sales')
          {
              this.storage.store('stgFromDate', this.FromDate);
              this.storage.store('stgToDate', this.ToDate);
              this.storage.store('stgItem', this.detitem);

              this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
              this.route.navigate(['report-vewier', 'CocReports/SalesItemsT']);
      }
        //////////==================== Stock Control ==================
    if( this.wk_Title == 'Item Balances' && this.Wk_Option =='T')
      {
          this.storage.store('stgFromDate', this.FromDate);
          this.storage.store('stgToDate', this.ToDate);
          this.storage.store('stgClass', this.itClass);
          this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
          this.route.navigate(['report-vewier', 'CocReports/ItemBalances']);
      }
    if( this.wk_Title == 'Item Balances' && this.Wk_Option =='D')
      {
            this.storage.store('stgFromDate', this.FromDate);
            this.storage.store('stgToDate', this.ToDate);
            this.storage.store('stgClass', this.itClass);
            this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
            this.route.navigate(['report-vewier', 'CocReports/ItemBalancesD']);
       }
    if( this.wk_Title == 'Item Card')
        {
            this.storage.store('stgFromDate', this.FromDate);
            this.storage.store('stgToDate', this.ToDate);
            this.storage.store('stgItem', this.detitem);
            this.storage.store('stgStore', this.hedstore);

            this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
            this.route.navigate(['report-vewier', 'CocReports/ItemCard']);
    }
    if( this.wk_Title == 'Price List' && this.PriceType =='1')
      {
          this.storage.store('stgClass', this.itClass);
          this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
          this.route.navigate(['report-vewier', 'CocReports/ItemCost']);
  }
  if( this.wk_Title == 'Price List' && this.PriceType =='2')
    {
        this.storage.store('stgClass', this.itClass);
        this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
        this.route.navigate(['report-vewier', 'CocReports/ItemSales']);
}


  if( this.wk_Title == 'Price List' && this.PriceType =='3')
  {
      this.storage.store('stgClass', this.itClass);
      this.storage.store('stgCompCode', this.storage.retrieve('stgcompCode'));
      this.route.navigate(['report-vewier', 'CocReports/ItemOrder']);
}
  }
  Exit(){}
  MessageWarrning(){

    swal({
      title: 'هناك خطأ ما ... نرجو التحقق',
      text: this.Wk_Worrning_Message,
      type: 'warning',
      showConfirmButton: false,

      timer: 1500
      });

  }
  LookupBanks(){
    this.lkpbanksService
    .getBankLookupTop(this.storage.retrieve('stgcompCode'))
    .subscribe((data: LkpBanksModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.bankList[i] = data[i];
      }

    });
  }
}
